module.exports = __webpack_public_path__ + "static/media/wildwildwebpage.fa98b904.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/portfolios/wildwildwebpage.png
// module id = 291
// module chunks = 0